document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.express-countdown-wrapper');

  wrappers.forEach(wrapper => {
    const expressTime = wrapper.dataset.expressTime;
    const expressBlock = wrapper.querySelector('.express-block');
    const regularBlock = wrapper.querySelector('.regular-block');
    const timerEl = wrapper.querySelector('.express-timer');

    if (!expressTime || !/^\d{2}:\d{2}$/.test(expressTime)) return;

    const [targetHour, targetMinute] = expressTime.split(':').map(Number);
    const targetDate = new Date();
    targetDate.setHours(targetHour, targetMinute, 0, 0);

    function updateCountdown() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        expressBlock.style.display = 'none';
        regularBlock.style.display = 'block';
        clearInterval(interval);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (timerEl) {
        timerEl.textContent = `${hours}h ${minutes}m ${seconds}s`;
      }
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Obtén el div que se va a mover
var divToMove = document.getElementById('m-app-section-template--19540977910010__1749621768dfb6fa83');

// Obtén el contenedor donde se moverá el div
var targetContainer = document.querySelector('#m-custom-template--19540977910010__custom_content_EdjeWJ .m-custom-content__wrapper');

// Verifica si el div y el contenedor existen
if (divToMove && targetContainer) {
  // Mueve el div al nuevo contenedor
  targetContainer.appendChild(divToMove);

  // Elimina la clase hidden-total
  divToMove.classList.remove('hidden-total');
}

});


document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('myModal');
  var openBtn1 = document.getElementById('openModalBtn1');
  var openBtn2 = document.getElementById('openModalBtn2');
  var closeBtn = document.getElementById('closeModalBtn');

  function abrirModal() {
    modal.style.display = 'flex';
  }

  openBtn1.onclick = abrirModal;
  openBtn2.onclick = abrirModal;

  closeBtn.onclick = function () {
    modal.style.display = 'none';
  };

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  };
});












